import service from '@/utils/server';

const modName='/md/deliveryWarehouse/';
//查询方法
export const pageInfo = data => {
  return service({
    url: modName + 'pageInfo',
    method: 'post',
    data
  });
};
//初始化页面对象
export const initPage = data => {
  return service({
    url: modName + 'initPage',
    method: 'post',
    data
  });
};
//初始化更新对象
export const initUpdate = data => {
  return service({
    url: modName + 'initUpdate/' + data,
    method: 'post',
    data
  });
};

export const getDeleteDeliveryWarehouse = data => {
  return service({
    url: modName+'delete/'+data.deliveryWarehouseId,
    method: 'post'
  })
};


//模板下载
export const downtemplate = data => {
  let config = {
    timeout: 500000, // 请求超时时间
    responseType: "blob"
  };
  return service({
    ...config,
    url: modName + 'template/' + data.templateName,
    method: 'post',
    data
  });
};

//导入
export const updateDeliveryWarehouseUpload = data => {
  let config = {
    responseType: "blob",
    timeout: 500000, // 请求超时时间
    headers: {
      "Content-Type": "multipart/form-data"
    },
  };
  return service({
    ...config,
    url: modName + 'updateDeliveryWarehouseUpload',
    method: 'post',
    data
  });
};
//导出
export const exportData = data => {
  let config = {
    timeout: 500000, // 请求超时时间
    responseType: "blob"
  };
  return service({
    ...config,
    url: modName + 'export',
    method: 'post',
    data
  });
};



// WEBPACK FOOTER //
// ./src/page/md/deliveryWarehouse/api/index.js